
import React from "react";

const TocFotosProgressLine = () => {
  return (
    <div className="absolute left-1/2 transform -translate-x-1/2 h-full top-0 z-10 pointer-events-none">
      <svg 
        width="2" 
        height="100%" 
        viewBox="0 0 2 1000" 
        fill="none" 
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M1 0V1000" 
          stroke="#FF5605" 
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};

export default TocFotosProgressLine;
